import React, { useState, useEffect, Fragment, lazy, Suspense } from 'react';
import classNames from 'classnames';
import './showNow.scss';
import { FormattedHTMLMessage, FormattedMessage, useIntl } from 'react-intl'
import {
  img_package_all,
  logo_lazada,
  logo_qoo10,
  app_icon,
} from '../../assets/imgs';
import { Shopee_icon } from '../commonComponents/svg';
import { language } from '../../index';

const ONLINE_STORES = process.env.REACT_APP_ONLINE_STORES || 'no';

const ShowNow = (props) => {
  const { formatMessage } = useIntl();
  const [isHomepage, setIsHomepage] = useState(false);

  useEffect(() => {
    location.href.indexOf('/home')>-1 ? setIsHomepage(true) : setIsHomepage(false);
  }, [location.href]);

  return (
    <React.Fragment>
      {/* Shop Now */}
      <section className="shop-now-wrapper" id="shop-now">
        <div className="shop-now-wrapper">
          <div className="decoration"></div>
          <div className="illustration content">
            <h3>
              <em><FormattedMessage id="showNow.title" defaultMessage="Shop Now" /></em>
            </h3>
            <img src={img_package_all} alt="Acuvue Define® products" />
          </div>
          <div className={classNames('button-stack content', ONLINE_STORES === 'yes' ? 'has-online-stores' : 'no-online-stores' )} >
            {/* Remove online-stores section and separator if there are no online shopping options */}
            { ONLINE_STORES === 'yes' && (
              <>
                <div className="online-stores details">
                  <p><FormattedMessage id="showNow.description" defaultMessage="Get exclusive deals on ACUVUE® brand products online now" /></p>
                  <div className="online-stores-buttons">
                    {/* <a
                      href="https://www.lazada.sg/shop/acuvue-official-store/"
                      target="_blank"
                      className="btn"
                    >
                      <img src={logo_lazada} />
                    </a>
                    <a
                      href="https://www.qoo10.sg/shop/acuvue"
                      target="_blank"
                      className="btn"
                    >
                      <img src={logo_qoo10} />
                    </a> */}
                    <a
                      href={formatMessage({ id: 'shopee_link', defaultMessage: 'https://shopee.sg/acuvuesg' })}
                      target="_blank"
                      className="btn"
                      id="shopee"
                    >
                      <Shopee_icon />
                      <span>Shopee</span>
                    </a>
                  </div>
                </div>

                <svg
                  className="separator"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 12 12"
                >
                  <path d="M6.55958 11.6668C6.32042 12.1124 5.68061 12.1124 5.44144 11.6668C4.87727 10.6141 4.15161 9.62576 3.26344 8.73759C2.37527 7.84942 1.38693 7.12375 0.334213 6.55958C-0.111404 6.32042 -0.111404 5.68061 0.334213 5.44144C1.38693 4.87727 2.37527 4.15161 3.26344 3.26344C4.15161 2.37527 4.87727 1.38693 5.44144 0.334213C5.68061 -0.111404 6.32042 -0.111404 6.55958 0.334213C7.12375 1.38693 7.84942 2.37527 8.73759 3.26344C9.62576 4.15161 10.6141 4.87727 11.6668 5.44144C12.1124 5.68061 12.1124 6.32042 11.6668 6.55958C10.6141 7.12375 9.62576 7.84942 8.73759 8.73759C7.84942 9.62576 7.12375 10.6141 6.55958 11.6668Z" />
                </svg>
              </>
            )}
            <div className="physical-stores details">
              { !(language == 'hk') && (
                <p><FormattedMessage id="showNow.physical.details" defaultMessage="Find your nearest authorised ACUVUE® store:" /></p>
              )}
              <a
                href={process.env.REACT_APP_FIND_ECP}
                target="_blank"
                className="btn primary"
              >
                <FormattedMessage id="buttonText.findStores" defaultMessage="Find Stores" />
                <div className="arrow btn-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 40 12"
                    fill="none"
                  >
                    <path d="M10.2 1C10.2 3.8 12.4 6 15.2 6C12.4 6 10.2 8.2 10.2 11M0.800049 6H15.3M34.2001 1C34.2001 3.8 36.4001 6 39.2001 6C36.4001 6 34.2001 8.2 34.2001 11M24.8 6H39.3" />
                  </svg>
                </div>
              </a>
            </div>
          </div>
          {/* Show Promo section only when Shop Now component is *not* on homepage */}
          {!isHomepage ? (<aside className="promo">
            <div className="coupon">
              <img src={app_icon} alt="MyACUVUE® App icon" />
              <h5><FormattedMessage id="download_now.title" defaultMessage="Enjoy $20 off your first purchase" /></h5>
              <p><FormattedMessage id="download_now.p" defaultMessage="Join MyACUVUE® now to unlock all privileges!" /></p>

              <FormattedMessage
              id="app_promo.cta_btn"
              defaultMessage="<a>Learn More</a>"
              values={{
                a: msg => (
                  <a
                    href={formatMessage({ id: 'app_promo.cta_link' })}
                    target="_blank"
                    className="btn secondary"
                  >
                    {msg}
                    <div className="new-tab btn-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 14" fill="none" overflow="visible" >
                        <path d="M12.75 1.75V5.25M12.75 1.75H9.25H12.75ZM12.75 1.75L7.5 7L12.75 1.75Z" />
                        <path d="M12.75 7.58333V11.0833C12.75 11.7277 12.2277 12.25 11.5833 12.25H3.41667C2.77233 12.25 2.25 11.7277 2.25 11.0833V2.91667C2.25 2.27233 2.77233 1.75 3.41667 1.75H6.91667" />
                      </svg>
                    </div>
                  </a>
                ),
              }}
            />
            </div>
          </aside>):''}
        </div>
      </section>
    </React.Fragment>
  );
};

export default ShowNow;
